import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "../../../../api/axios";
import {
  DocumentInput,
  EmailInput,
  TextFieldComponent,
} from "../../../../components/misc/form";

const PERMISSIONS = [
  { value: "SUPER_ADMIN", label: "Administrador" },
  { value: "SELLER", label: "Operador" },
  //{ value: "CUSTOMER", label: "Cliente" },
];

const CreateCustomer = () => {
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
  } = useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (form) => {
    let success = false;
    try {
      setLoading(true);

      await axios.post("/users/create", form);
      success = true;
    } catch (err) {
      success = false;
      alert(axios.getError(err, "Não foi possível registrar usuário!"));
    } finally {
      setLoading(false);
      if (success) {
        alert("Usuário cadastrado com sucesso!");
        navigate("./../");
      }
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Cadastro de Usuário
      </Typography>

      <Paper sx={{ p: 2 }}>
        <form onSubmit={formSubmit(handleSubmit)}>
          <Grid container spacing={2} mt={1}>
            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
              <TextFieldComponent
                disabled={loading}
                name="name"
                control={control}
                label={"Nome"}
                fullWidth
                required
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <DocumentInput
                disabled={loading}
                control={control}
                fullWidth
                size="small"
                required
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <EmailInput
                disabled={loading}
                control={control}
                fullWidth
                size="small"
                required
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <TextFieldComponent
                disabled={loading}
                name="username"
                control={control}
                label={"Usuário"}
                fullWidth
                required
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <TextFieldComponent
                disabled={loading}
                name="password"
                control={control}
                label={"Senha"}
                fullWidth
                required
                type="password"
              />
            </Grid>
          </Grid>
          <Typography variant="h6" mt={3}>
            Perfil de usuário
          </Typography>

          <Grid container spacing={2} mt={1}>
            <Grid>
              <FormControl>
                <RadioGroup defaultValue={"SELLER"} name={"profile"}>
                  {PERMISSIONS.map(({ value, label }) => (
                    <FormControlLabel
                      {...register("profile")}
                      key={value}
                      value={value}
                      control={<Radio disabled={loading} />}
                      label={label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Button
            loading={loading}
            variant="contained"
            color="primary"
            type="submit"
            sx={{ mt: 3 }}
          >
            Salvar
          </Button>
        </form>
      </Paper>

      <Snackbar open={success} autoHideDuration={3000}>
        <Alert severity="success">Cliente cadastrado com sucesso!</Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateCustomer;
